import { useNavigation } from "@react-navigation/native";
import { useEffect, useState } from "react";

// We get an error when trying to navigate to a screen and the navigation state is not ready.
// Use this hook to check if the navigation state is ready before navigating inside _layout components.
export function useIsNavigationReady() {
  const [isNavigationReady, setIsNavigationReady] = useState(false);
  const navigation = useNavigation();
  const navigationState = navigation.getState();
  const isNavigationStateReady = !!navigationState?.key;

  useEffect(() => {
    if (isNavigationStateReady && !isNavigationReady) {
      setIsNavigationReady(true);
    }
  }, [isNavigationReady, isNavigationStateReady]);

  return isNavigationReady;
}
